var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSlider
    ? _c("div", { ref: "sliderOuterDom", staticClass: "vue-slider" }, [
        _c(
          "ul",
          { ref: "sliderListDom", staticClass: "vue-slider-ul" },
          _vm._l(_vm.scrollList, function(item, index) {
            return _c("li", { staticClass: "vue-slider-ul-li" }, [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      return _vm.gotoLink(item.linkUrl, item)
                    }
                  }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.initedList,
                        expression: "initedList"
                      }
                    ],
                    staticClass: "vue-slider-ul-li-img",
                    attrs: { "data-src": item.imgUrl, src: "" }
                  })
                ]
              )
            ])
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-f76b79b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f76b79b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./components/ScrollList.vue
// module id = eJ28
// module chunks = 7